import { ArtworkBreakPointConfig } from '@/common/components/ArtworkPicture/artworksBreakpoints.config';
import { ArtworkResolutions, imageCoreToUrl } from '@/common/components/ArtworkPicture/artworkUri';
import { ImgExtension } from '@/common/types/Artwork/Artwork.type';
import { ArtworkOrientation } from 'generatedBfw/static';

export const ZoomPdpSrcSet = (imageCoreUrl: string, orientation: ArtworkOrientation): string => {
  if (!imageCoreUrl) return '';

  const src1 = imageCoreToUrl(imageCoreUrl, ArtworkResolutions.rect.rect1422x1016, orientation);
  const src2 = imageCoreToUrl(imageCoreUrl, ArtworkResolutions.rect.rect2844x2032, orientation);

  return `${src1}.jpg 1x, ${src2}.jpg 2x`;
};

export const GeneralPdpSizes = '(max-width: 480px) 392px, (max-width: 1280px) 640px, 992px'; // This is just a POC, needs to be changed with final designs

export const generalImageFallback = (
  imageCoreUrl: string,
  orientation: ArtworkOrientation,
): string => {
  if (!imageCoreUrl) return '';

  const src1 = imageCoreToUrl(imageCoreUrl, ArtworkResolutions.rect.rect380x270, orientation);

  return `${src1}.jpg`;
};

export const artworkPictureSourceSet = (
  imageCoreUrl: string,
  orientation: ArtworkOrientation,
  extension: ImgExtension,
  breakpoint: number,
  artworkSets: ArtworkBreakPointConfig,
): string => {
  if (!imageCoreUrl) return '';

  const src1 = imageCoreToUrl(imageCoreUrl, artworkSets[breakpoint].x1, orientation);
  const src2 = imageCoreToUrl(imageCoreUrl, artworkSets[breakpoint].x2, orientation);

  return `${src1}.${extension} 1x, ${src2}.${extension} 2x`;
};
